<script lang="ts" setup>
</script>

<template>
  <div v-once>
    <div class="mx-auto my-40 max-w-1200 <sm:px-16 <xl:px-24">
      <h1 class="text-center">开放原子开源基金会品牌使用指南</h1>
      <p class="text-center">版本号: 2.2</p>

      <p class="indent-2em">
        开放原子开源基金会（下称“基金会”）作为致力于繁荣开源生态的非营利组织，享有基金会及旗下各开源项目相关商标和字号的标识性权利/权益（下称“基金会品牌”），包括但不限于《基金会品牌清单》所列示的标识。
      </p>
      <p class="indent-2em">
        为合法、规范、高效地使用和宣传基金会品牌，维护基金会品牌开放、中立的核心价值，基金会特此发布统一适用于基金会及旗下开源项目的《开放原子开源基金会品牌使用指南》（下称“本指南”）。
      </p>

      <h4>一、适用范围</h4>

      <p class="indent-2em">
        本指南适用于任何相关公众（不论为自然人、法人或非法人主体，下称“您”）使用基金会品牌的情形，尤其包括参与开源生态共建的应用方、贡献方和合作方（如基金会的捐赠人、开源项目工作委员会及下设组织、开源项目/社区的成员等）使用基金会品牌的情形。
      </p>

      <h4>二、使用规范</h4>

      <p class="indent-2em">在任何情形下，使用基金会品牌均应遵循本指南以下基本使用要求：</p>

      <h4>1. 善意使用要求</h4>

      <ul>
        <li><p>除本指南第三条第1款情形外，您使用基金会品牌均应事先与基金会或旗下对应的开源项目沟通取得相应授权后方可使用。</p></li>
        <li><p>您不应以任何诽谤、贬损方式使用基金会品牌。</p></li>
        <li><p>您不应以任何虚假、误导性方式使用基金会品牌，包括不应擅自将基金会品牌作为字号或名称的显著识别部分使用，不应以“基金会品牌+产品/服务的通用名称”方式使用，以免引人误认相关主体、产品或服务为基金会或旗下开源项目官方指定/发布。</p></li>
        <li><p>您不应擅自使用容易与基金会品牌混淆的近似标识、广告语、宣传口号等。</p></li>
      </ul>

      <h4>2. 规范使用要求</h4>

      <ul>
        <li>
          <p>
            在使用纯文字品牌时，您应当完整使用品牌，不应移除、扭曲或篡改基金会品牌任何元素，包括但不限于改变文字/字母的排列顺序、大小写、比例、颜色、拆分、换行等。<br>
            正确示例：<br>
            －提及基金会名称时，应使用全称“开放原子开源基金会”/“OpenAtom Foundation”，或使用完整字号简称“开放原子”/“OpenAtom”。<br>
            －提及“OpenHarmony”项目中文名称时，应完整使用“开源鸿蒙”而不得单独使用“鸿蒙”，亦不得将“开源鸿蒙”与“鸿蒙”进行替代或混同使用。
          </p>
        </li>
        <li><p>在使用Logo标识时，您应使用基金会及旗下开源项目所发布的标准式样。</p></li>
        <li><p>基金会品牌存在相应视觉规范的，您应进一步遵守该规范中的具体要求。</p></li>
        <li><p>您不应擅自对基金会品牌进行二次创作、不应擅自以基金会品牌作为装饰元素等方式滥用基金会品牌。</p></li>
      </ul>

      <h4>三、使用情形</h4>

      <h4>1. 无须授权即可使用的情形</h4>

      <p class="indent-2em">在以下情形中，您可以按指定形式使用基金会品牌，无须寻求基金会或对应的开源项目另行授权：</p>

      <ul>
        <li>
          <p>
            在宣传材料（如PPT、宣传册、新闻稿）中，为准确表述相关事实，以文字形式使用基金会品牌。<br>
            正确示例：<br>
            －AAA（您的企业全称/商号）是XXX（基金会旗下开源项目名称）的设备开发者/发行版厂商/应用开发者；<br>
            －基于XXX（基金会旗下开源项目名称）的模组/开发板/板卡/设备/整机/商业发行版/商用软件。
          </p>
        </li>
        <li>
          <p>
            在网络页面上，为设置指向基金会及旗下开源项目官网页面的超链接，以文字或Logo形式使用基金会品牌。<br>
            正确示例：<br>
            －使用基金会旗下开源项目Logo的标准样式作为跳转至该开源项目官网页面的超链接按钮。
          </p>
        </li>
        <li>
          <p>
            为开源文化推广、学术研讨或技术交流目的，在文化周边产品（如T恤、帽子、包袋）上印制文字或Logo形式的基金会品牌，且不得同时展示任何商业品牌。<br>
            正确示例：<br>
            －向参与开源相关活动的开源爱好者免费赠送印制有基金会或旗下开源项目Logo的帆布包。
          </p>
        </li>
        <li>
          <p>
            为开源文化推广、学术研讨或技术交流目的，在有关会议、赛事、活动中，以文字形式使用基金会旗下开源项目名称，以如实表明相应主题内容。<br>
            正确示例：<br>
            －举办以XXX（基金会旗下开源项目名称）技术应用为主题的活动，可以使用“XXX（基金会旗下开源项目名称）技术沙龙”为名，但不得使用相关开源项目Logo。
          </p>
        </li>
        <li>
          <p>
            为推广开源文化、学术研讨或技术交流目的，在有关书籍的名称和内容中以文字形式使用基金会旗下开源项目名称，以如实表明相应主题内容。<br>
            正确示例：<br>
            －出版主题为XXX（基金会旗下开源项目名称）相关技术应用的书籍，可以使用《XXX（基金会旗下开源项目名称）技术应用》为书名，但不得使用相关开源项目Logo。
          </p>
        </li>
      </ul>

      <h4>2. 经授权后方可使用的情形</h4>

      <p class="indent-2em">
        除前述“无须授权即可使用的情形”外，使用基金会品牌均应事先取得基金会或对应的开源项目的授权，包括但不限于以下情形：
      </p>

      <ul>
        <li><p>以超出本条第1款所指定形式使用基金会品牌，如在有关活动中使用开源项目Logo形式，或在文化周边产品上将基金会品牌与商业品牌组合或联名使用。</p></li>
        <li><p>在实体/机构/组织/场所/区域等名称中使用基金会品牌，如XX兼容性测评中心/生态服务中心/培训中心/实训基地/创新中心/研究院/促进中心/生态示范区/产业小镇/之城等（尤其在涉及地方政府合作时）。</p></li>
        <li><p>在网络账号（如微信、微博名、店铺名称等）、域名中使用基金会品牌。</p></li>
        <li><p>在荣誉证书、资质证书等文件上使用基金会品牌。</p></li>
        <li><p>对另有专项授权安排的基金会品牌，应按相关安排执行（如开源鸿蒙兼容性标识，仅限于签署《OpenHarmony兼容性协议》的生态伙伴在其通过兼容性测评的对应型号设备、设备包装和营销物料上、按照《开源鸿蒙兼容性标识使用指引》规范使用）。</p></li>
      </ul>

      <h4>四、商标权属标注</h4>

      <p class="indent-2em">
        基金会及旗下开源项目相关标识的所有知识产权及合法权益由基金会享有。欢迎您在使用基金会品牌的同一界面适当位置注明“【XXX™】是开放原子开源基金会享有权益的商标”。
      </p>

      <h4>五、授权终止</h4>

      <p class="indent-2em">
        基于本指南，您就基金会品牌取得的品牌授权均为可撤销、非独占、不可转让、不可分许可的普通授权。如出现以下情况，前述授权立即自动终止：
      </p>

      <ul>
        <li><p>您使用基金会品牌违反本指南或相关视觉规范（如有）的任何要求。</p></li>
        <li><p>您直接或间接地挑战基金会品牌相关的商标或其他合法权益，包括但不限于（a）对基金会的任何商标提起异议、无效、撤销程序；（b）通过注册、转让、转移等方式获取与基金会品牌相同或近似的商标、字号、网络账号（如微信、微博名、店铺名称等）、域名或其他标识。</p></li>
        <li><p>您的行为违反国家法律法规、规章制度或社会公序良俗，或损害基金会及旗下开源项目开放、中立、非营利的公益品牌形象或其他正当权益。</p></li>
      </ul>

      <h4>六、声明</h4>

      <p class="indent-2em">
        基金会及旗下开源项目均不对基金会品牌做出任何明示或暗示的保证，包括但不限于基金会品牌不存在任何知识产权争议、基金会品牌的任何商标申请均可获得注册商标保护的保证等。您同意自行承担使用基金会品牌而引发相关索赔的所有责任，并承诺使基金会及旗下开源项目、开源项目的贡献者免于承担任何索赔相关责任。
      </p>
      <p class="indent-2em">
        本指南任何内容（含示例）均不影响基金会及旗下开源项目依法享有的任何权益和主张、不构成任何权益的转让或转移。
      </p>

      <h4>七、监督与反馈</h4>

      <p class="indent-2em">
        基金会持续对开源生态各方使用基金会品牌的情况进行抽查，并保留追究对基金会品牌违规使用、侵权使用行为法律责任的权利。
      </p>
      <p class="indent-2em">
        如您对本指南或具体视觉规范的相关内容有任何疑问，或您发现任何疑似侵权使用、违规使用或滥用基金会品牌的情况，欢迎通过<a href="mailto:report@openatom.org">report@openatom.org</a>向基金会反馈。
      </p>

      <h4>八、更新</h4>

      <p class="indent-2em">
        本指南可能会不定期修订，并在基金会官方网站发布更新版本。请您在每次使用、申请使用基金会品牌前确认符合本指南最新版本的要求。
      </p>

      <h4>附件：基金会品牌清单</h4>

      <p class="indent-2em">
        为方便您了解基金会品牌使用指南涉及的主要品牌标识，基金会整理并持续更新以下基金会品牌清单。
      </p>

      <div class="<md:overflow-x-auto">
        <table class="mx-auto mt-10px w-full border-collapse border border-#ddd border-solid <md:min-w-640px">
          <thead>
            <tr class="bg-#f2f2f2">
              <th class="border border-#ddd border-solid p-8px" width="14%">类别</th>
              <th class="border border-#ddd border-solid p-8px" width="24%">文字商标</th>
              <th class="border border-#ddd border-solid p-8px" width="34%">Logo商标</th>
              <th class="border border-#ddd border-solid p-8px">备注</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="8" class="border border-#ddd border-solid p-8px text-center">机构品牌</td>
              <td class="border border-#ddd border-solid p-8px text-center">开放原子开源基金会</td>
              <td rowspan="2" class="border border-#ddd border-solid p-8px text-center">
                <p>（Logo标准样式：横版、竖版）</p>
                <p class="flex-center flex-wrap gap-24px">
                  <img src="@/assets/other/brand-guide/1.png" alt="开放原子开源基金会横版Logo" class="max-h-44px max-w-240px">
                  <img src="@/assets/other/brand-guide/2.png" alt="开放原子开源基金会竖版Logo" class="max-h-72px max-w-140px">
                </p>
              </td>
              <td rowspan="8" class="border border-#ddd border-solid p-8px text-center">机构品牌使用事宜请联系<a href="mailto:tm@openatom.org">tm@openatom.org</a></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">OpenAtom Foundation</td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">AtomGit</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">开放原子校源行</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">校源行</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">心寄源</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">源译识</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">源规律</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>

            <tr>
              <td rowspan="33" class="border border-#ddd border-solid p-8px text-center">开源项目品牌</td>
              <td class="border border-#ddd border-solid p-8px text-center">开源鸿蒙</td>
              <td rowspan="2" class="border border-#ddd border-solid p-8px text-center">
                <p>（Logo标准样式：横版、竖版）</p>
                <p class="flex-center flex-wrap gap-24px">
                  <img src="@/assets/other/brand-guide/3.png" alt="开源鸿蒙横版Logo" class="max-h-80px max-w-260px">
                  <img src="@/assets/other/brand-guide/4.png" alt="开源鸿蒙竖版Logo" class="max-h-84px max-w-150px">
                </p>
              </td>
              <td rowspan="2" class="border border-#ddd border-solid p-8px text-center">
                <a target="_blank" href="https://openharmony.cn/Dictionary">视觉规范</a>
                <p>本项目品牌使用事宜请联系<a href="mailto:pr@mail.openharmony.io">pr@mail.openharmony.io</a></p>
              </td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">OpenHarmony</td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">Powered by OpenHarmony</td>
              <td class="border border-#ddd border-solid p-8px text-center">
                <p>（兼容性标识标准样式：标准、反白、单色黑）</p>
                <p class="flex-center flex-wrap gap-16px">
                  <img src="@/assets/other/brand-guide/5.png" alt="Powered by OpenHarmony标准标识" class="max-h-72px max-w-210px">
                  <img src="@/assets/other/brand-guide/6.png" alt="Powered by OpenHarmony反白标识" class="max-h-72px max-w-210px">
                  <img src="@/assets/other/brand-guide/7.png" alt="Powered by OpenHarmony单色黑标识" class="max-h-72px max-w-210px">
                </p>
              </td>
              <td class="border border-#ddd border-solid p-8px text-center">
                <a target="_blank" href="https://openharmony.cn/guide">开源鸿蒙兼容性标识使用指引</a>
                <p>本项目品牌使用事宜请联系<a href="mailto:pr@mail.openharmony.io">pr@mail.openharmony.io</a></p>
              </td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">开源欧拉</td>
              <td rowspan="2" class="border border-#ddd border-solid p-8px text-center">
                <p>（Logo标准样式：横版、竖版）</p>
                <p class="flex-center flex-wrap gap-24px">
                  <img src="@/assets/other/brand-guide/8.png" alt="开源欧拉横版Logo" class="max-h-56px max-w-210px">
                  <img src="@/assets/other/brand-guide/9.png" alt="开源欧拉竖版Logo" class="max-h-68px max-w-120px">
                </p>
              </td>
              <td rowspan="2" class="border border-#ddd border-solid p-8px text-center">
                <a target="_blank" href="https://www.openeuler.openatom.cn/zh/other/brand/specification/">视觉规范</a>
                <p>本项目品牌使用事宜请联系<a href="mailto:trademarks@openeuler.sh">trademarks@openeuler.sh</a></p>
              </td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">openEuler</td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">openKylin</td>
              <td class="border border-#ddd border-solid p-8px text-center">
                <img src="@/assets/other/brand-guide/10.png" alt="openKylin Logo" class="max-h-50px max-w-220px">
              </td>
              <td class="border border-#ddd border-solid p-8px text-center">本项目品牌使用事宜请联系<a href="mailto:contact@openKylin.top">contact@openKylin.top</a></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">开源青龙</td>
              <td rowspan="2" class="border border-#ddd border-solid p-8px text-center">
                <img src="@/assets/other/brand-guide/11.png" alt="开源青龙 Logo" class="max-h-72px max-w-250px">
              </td>
              <td rowspan="27" class="border border-#ddd border-solid p-8px text-center">各项目品牌使用事宜请联系<a href="mailto:tm@openatom.org">tm@openatom.org</a></td>
            </tr>
            <tr><td class="border border-#ddd border-solid p-8px text-center">OpenLoong</td></tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">铜锁</td>
              <td rowspan="2" class="border border-#ddd border-solid p-8px text-center">
                <img src="@/assets/other/brand-guide/12.png" alt="铜锁 Logo" class="max-h-76px max-w-190px">
              </td>
            </tr>
            <tr><td class="border border-#ddd border-solid p-8px text-center">Tongsuo</td></tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">元遨</td>
              <td rowspan="2" class="border border-#ddd border-solid p-8px text-center">
                <img src="@/assets/other/brand-guide/13.png" alt="元遨 Logo" class="max-h-56px max-w-170px">
              </td>
            </tr>
            <tr><td class="border border-#ddd border-solid p-8px text-center">Carsmos</td></tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">开源腾贝</td>
              <td rowspan="2" class="border border-#ddd border-solid p-8px text-center">
                <img src="@/assets/other/brand-guide/14.png" alt="开源腾贝 Logo" class="max-h-56px max-w-330px">
              </td>
            </tr>
            <tr><td class="border border-#ddd border-solid p-8px text-center">OpenTenBase</td></tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">如意玲珑</td>
              <td rowspan="2" class="border border-#ddd border-solid p-8px text-center">
                <img src="@/assets/other/brand-guide/15.png" alt="如意玲珑 Logo" class="max-h-64px max-w-190px">
              </td>
            </tr>
            <tr><td class="border border-#ddd border-solid p-8px text-center">Linyaps</td></tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">多萝珍奇引擎</td>
              <td rowspan="2" class="border border-#ddd border-solid p-8px text-center">
                <img src="@/assets/other/brand-guide/16.png" alt="多萝珍奇引擎 Logo" class="max-h-48px max-w-80px">
              </td>
            </tr>
            <tr><td class="border border-#ddd border-solid p-8px text-center">Dora SSR</td></tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">恩捷客</td>
              <td rowspan="2" class="border border-#ddd border-solid p-8px text-center">
                <img src="@/assets/other/brand-guide/17.png" alt="恩捷客 Logo" class="max-h-76px max-w-240px">
              </td>
            </tr>
            <tr><td class="border border-#ddd border-solid p-8px text-center">OpenNJet</td></tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">PikiwiDB</td>
              <td class="border border-#ddd border-solid p-8px text-center">
                <img src="@/assets/other/brand-guide/18.png" alt="PikiwiDB Logo" class="max-h-72px max-w-300px">
              </td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">TobudOS</td>
              <td class="border border-#ddd border-solid p-8px text-center">
                <img src="@/assets/other/brand-guide/19.png" alt="TobudOS Logo" class="max-h-58px max-w-130px">
              </td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">UBML</td>
              <td class="border border-#ddd border-solid p-8px text-center">
                <img src="@/assets/other/brand-guide/20.png" alt="UBML Logo" class="max-h-60px max-w-210px">
              </td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">源师兄</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">hapjs</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">UBSICE</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">HyperBench</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">RT-TKERN</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">ZTDBP</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">OpenNJet</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">PYSTOR DBS</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">KWDB</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
            <tr>
              <td class="border border-#ddd border-solid p-8px text-center">openDACS</td>
              <td class="border border-#ddd border-solid p-8px text-center"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
</style>
